import React from 'react';
import image from '../../images/lili.png'
import { useDispatch } from 'react-redux';
import { setModalStage } from '../../store/modalSlice';
import Button from '../../share/button/Button';

const ConnectSuccesEth = () => {
    const dispatch = useDispatch();
    const successConnect = () => {
        dispatch(setModalStage('PUBLIC_MINT'));
    }
    return (
        <div className="flex flex-col items-center gap-2">
            <img src={image} className="w-[150px] sm:w-[190px] h-auto mb-2" alt="Lili" />
            <div className="flex flex-col gap-3 items-center w-full">
                <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white text-center">Nice! You have successfully connected <br /> your wallet.</p>
                <Button onClick={successConnect} size="cta" className="mt-2">CONTINUE</Button>
            </div>
        </div>
    );
};

export default ConnectSuccesEth;
